var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c(
          "div",
          [
            _c(
              "v-overlay",
              { staticClass: "waitoverlay", attrs: { value: _vm.busy } },
              [
                _c("v-progress-circular", {
                  staticClass: "mr-4",
                  attrs: { indeterminate: "", size: "64" }
                }),
                _vm._v(" " + _vm._s(_vm.$t("global.loading")) + " ")
              ],
              1
            )
          ],
          1
        )
      : _vm.rawHtml
      ? _c("div", {
          staticClass: "learner-report",
          domProps: { innerHTML: _vm._s(_vm.rawHtml) }
        })
      : _vm.errorMessage
      ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.errorMessage))])])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }